import SearchResultsPage from './SearchResultsPage';

export default SearchResultsPage;
export { getServerSideProps } from './serverSideProps';
